/** Conta bancária do creator (resposta de GET /creator/me/bank-accounts) */
export interface CreatorBankAccount {
  id: string;
  bank: string;
  code: string;
  branch: string;
  account: string;
  pix: string;
  active: boolean;
  default: boolean;
  createdAt?: string;
  lastUpdatedAt?: string;
}

/** Payload para PUT /creator/me/bank-accounts/:id */
export interface UpdateCreatorBankAccountPayload {
  bank?: string;
  code?: string;
  branch?: string;
  account?: string;
  pix?: string;
  default?: boolean;
}

/** Payload para POST /creator/me/bank-accounts (criar nova conta) */
export interface CreateCreatorBankAccountPayload {
  bank: string;
  code: string;
  branch: string;
  account: string;
  pix: string;
  default: boolean;
}

/** Snapshot de recebível por mês (GET /creator/me/receivable-snapshots) */
export type ReceivableSnapshotStatus = "WAITING" | "CALCULATED" | "CONCLUDED";

export interface CreatorReceivableSnapshot {
  paymentMonth: string;
  status: ReceivableSnapshotStatus;
  currency: string;
  grossAmount: number;
  netAmount: number;
  shareAmount: number;
  sharePercentage: number;
  calculatedAt?: string;
}

export interface GetCreatorReceivableSnapshotsParams {
  page?: number;
  limit?: number;
  /** Período: 6 ou 12 meses */
  periodMonths?: number;
}

/** Resposta paginada de receivable-snapshots */
export interface PaginatedCreatorReceivableSnapshotsResponse {
  data: CreatorReceivableSnapshot[];
  page: number;
  limit: number;
  totalItems: number;
  totalPage?: number;
}

/** Status de pagamento (GET /creator/me/payments) */
export enum CreatorPaymentStatus {
  PAID = "PAID",
  PENDING = "PENDING",
  SCHEDULED = "SCHEDULED",
  ERROR = "ERROR",
}

export interface CreatorPaymentBankAccount {
  bank: string;
  account: string;
  pix: string;
}

export interface CreatorPayment {
  id: string;
  status: CreatorPaymentStatus;
  value: number;
  paymentDate: string;
  referencePaymentDate?: string | null;
  bankAccount?: CreatorPaymentBankAccount | null;
  createdAt: string;
}

export interface GetCreatorPaymentsParams {
  page?: number;
  limit?: number;
  status?: CreatorPaymentStatus | "all";
  search?: string;
}

export interface PaginatedCreatorPaymentsResponse {
  data: CreatorPayment[];
  page: number;
  limit: number;
  totalItems: number;
  totalPage?: number;
}
